import { PaletteOptions } from '@mui/material';

const setCssVariables = (
  palette: PaletteOptions,
  groupColorsToAdd: string[],
): void => {
  const root = document.documentElement;
  groupColorsToAdd.forEach((color) => {
    const colorValue = palette[color];
    if (colorValue) {
      Object.entries(colorValue).forEach(([key, value]) => {
        root.style.setProperty(`--color-${color}-${key}`, value as string);
      });
    }
  });
};

export { setCssVariables };
